import {TweenMax, Power4} from 'gsap';
// @ts-ignore
import Headroom from 'headroom.js';

export class Navigation {
    private readonly nav: HTMLElement = <HTMLElement>document.querySelector(".js-nav");
    private readonly navBtn: HTMLElement = <HTMLElement>document.querySelector(".js-nav-btn");
    private readonly body: HTMLElement = <HTMLElement>document.querySelector("body");
    private readonly mobileNav: HTMLElement = <HTMLElement>document.querySelector(".js-mobile-nav");
    private isOpened = false;

    constructor() {
        if (this.nav && this.navBtn) {
            this.init();

            let headroom = new Headroom(this.mobileNav, {
                offset: 300,
                tolerance: 5,
                classes: {
                    pinned: "c-mobile-navigation--pinned",
                    unpinned: "c-mobile-navigation--unpinned",
                },
            });
            headroom.init();
        }
    }

    private init(): void {
        this.navBtn.addEventListener('click', () => {
            if (!this.isOpened) {
                this.openNav();
                return;
            }

            this.closeNav();
        });
    }

    private openNav(): void {
        this.navBtn.classList.add('is-active');
        this.body.classList.add('is-locked');
        this.isOpened = true;

        TweenMax.to(this.nav, 0.8, {
            x: '0%',
            force3D: true,
            ease: Power4.easeOut,
        });
    }

    private closeNav(): void {
        this.navBtn.classList.remove('is-active');
        this.body.classList.remove('is-locked');
        this.isOpened = false;

        TweenMax.to(this.nav, 0.6, {
            x: '-100%',
            force3D: true,
            ease: Power4.easeOut,
        });
    }


}
